import React from 'react';
import msflending from '../img/clientsLogo/msflending.png';
import back from '../img/clientsLogo/back.png';
import logo22 from '../img/clientsLogo/22.png';
import interlatina from '../img/clientsLogo/interlatina.png';
import wt from '../img/clientsLogo/wt.png';
import letca from '../img/clientsLogo/letca.png';
import lockton from '../img/clientsLogo/lockton.png';
import corazonMexica from '../img/clientsLogo/Corazon Mexica Logo.png';
import growie from '../img/illustrations/growie.png';
// import ultra from '../img/clientsLogo/ultra.png'; // Hidden temporarily
// import thevoiceofforeignservice from '../img/clientsLogo/thevoiceofforeignservice.png'; // Moved to Featured in section

const ClientsLogo = ({ language = 'en' }) => {
    const clients = [
        { name: 'MSF Lending', logo: msflending, url: 'https://msflendinginc.com/' },
        { name: 'BACX', logo: back, url: 'https://www.bacx.com.ar/en/' },
        { name: 'TI22 Productions', logo: logo22, url: 'https://ti22productions.com/' },
        { name: 'Interlatina', logo: interlatina, url: 'https://interlatina.org/es/' },
        { name: 'Work & Hols', logo: wt, url: 'https://workandhols.com.ar/' },
        { name: 'Letca', logo: letca, url: 'https://letca.com/' },
        { name: 'Lockton', logo: lockton, url: 'https://global.lockton.com/ar/es' },
        { name: 'Corazón Mexica', logo: corazonMexica, url: 'https://www.instagram.com/micorazonmexica/?hl=es' },
        { name: 'GROWIE', logo: growie, url: 'https://growie.io', large: true }
        // { name: 'Ultra Padel Club', logo: ultra, url: 'https://ultrapadelclub.com/' }, // Hidden temporarily
        // { name: 'The Voice of the Foreign Service', logo: thevoiceofforeignservice, url: null } // Moved to Featured in section
    ];

    const title = language === 'es' ? 'Nuestros Clientes' : 'Trusted by';
    const subtitle = language === 'es' 
        ? 'Empresas que confían en nuestros servicios profesionales' 
        : 'Companies that trust our professional services';

    return (
        <section className="bg-light py-10">
            <div className="container px-5">
                <div className="text-center mb-8">
                    <h2 className="mb-3">{title}</h2>
                    <p className="lead text-muted">{subtitle}</p>
                </div>
                <div className="row gx-5 justify-content-center align-items-center">
                    {clients.map((client, index) => (
                        <div 
                            key={index} 
                            className={client.large ? 'col-lg-4 col-md-6 col-8 mb-5' : 'col-lg-3 col-md-4 col-6 mb-5'}
                            data-aos="fade-up"
                            data-aos-delay={index * 100}
                        >
                            <div className="client-logo-container text-center">
                                {client.url ? (
                                    <a 
                                        href={client.url} 
                                        target="_blank" 
                                        rel="noopener noreferrer"
                                        className="client-logo-link"
                                        style={{ textDecoration: 'none' }}
                                    >
                                        <img 
                                            src={client.logo} 
                                            alt={`${client.name} logo`}
                                            className={`img-fluid client-logo${client.large ? ' client-logo-large' : ''}`}
                                            style={{
                                                maxHeight: client.large ? '160px' : '80px',
                                                maxWidth: client.large ? '320px' : '200px',
                                                transition: 'all 0.3s ease'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.transform = 'scale(1.05)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.transform = 'scale(1)';
                                            }}
                                        />
                                    </a>
                                ) : (
                                    <img 
                                        src={client.logo} 
                                        alt={`${client.name} logo`}
                                        className={`img-fluid client-logo${client.large ? ' client-logo-large' : ''}`}
                                        style={{
                                            maxHeight: client.large ? '160px' : '80px',
                                            maxWidth: client.large ? '320px' : '200px',
                                            transition: 'all 0.3s ease'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.transform = 'scale(1.05)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.transform = 'scale(1)';
                                        }}
                                    />
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ClientsLogo;
